export const environment = {
  production: true,
  //Prod Url
// apiUrl: 'https://carrierapp.shift.in:8443/carrier/',

  //Dev Url
  //apiUrl: 'https://carrierdevapp.shift.in:8443/carrier/',

  //Local use
  //apiUrl: 'http://192.168.1.207:8080/carrier/',
  //apiUrl: 'https://carrierapi.snithik.com/carrier/',

  //apiUrl: 'http://localhost:9002/',
  apiUrl: 'https://fcapi.snithik.com/',
  razorPayKey: 'rzp_test_KakF4Dy4HjXa1U'

};
